import ApiDefault from "../../ApiDefault";

export default function ApiOperationsNature() {
    const apiDefault = ApiDefault("v2/basics/operations-nature");

    return {
        apiDefault,
    };
}
